import { useState, useCallback } from 'react';

/**
 * Custom hook for managing snackbar/notification state
 * @param {Object} initialState - Initial snackbar state
 * @returns {Object} { snackbar, showSnackbar, hideSnackbar }
 */
export const useSnackbar = (initialState = { open: false, message: '', severity: 'success' }) => {
  const [snackbar, setSnackbar] = useState(initialState);

  const showSnackbar = useCallback((message, severity = 'success') => {
    setSnackbar({
      open: true,
      message,
      severity
    });
  }, []);

  const hideSnackbar = useCallback(() => {
    setSnackbar(prev => ({
      ...prev,
      open: false
    }));
  }, []);

  return {
    snackbar,
    showSnackbar,
    hideSnackbar
  };
};
